import { Box, styled } from '@mui/material';

export const ToolTipLine = styled(Box)(({ theme }) => ({
  width: '1px',
  height: theme.spacing(18),
  backgroundColor: theme.palette.black.A100,
  position: 'absolute',
  bottom: '-15px',
  left: '50%',
}));

export const ToolTipRound = styled(Box)(({ theme }) => ({
  width: theme.spacing(5),
  height: theme.spacing(5),
  backgroundColor: theme.palette.black.A100,
  borderRadius: theme.spacing(5),
  position: 'absolute',
  bottom: '-18px',
  left: '48%',
}));
